import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    name: 'Login'
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/dashboard',
    component: Layout,
    name: 'dashboard',
    redirect: '/dashboardManagement',
    meta: { title: '综合统计', icon: 'ali_home_fill' },
    children: [
      {
        path: '/dashboardManagement',
        component: () => import('@/views/dashboard'),
        name: 'dashboardManagement',
        meta: { title: '综合统计', icon: 'none' },
        hidden: true
      }
    ]
  },
  // {
  //     path: '/user',
  //     component: Layout,
  //     redirect: '/userManagement',
  //     name: 'userManagement',
  //     meta: {title: '商户管理', icon: 'none'},
  //     children: [
  //         {
  //             path: '/userManagement',
  //             component: () => import('@/views/user/userManagement'),
  //             name: 'userManagement',
  //             meta: {title: '商户信息', icon: 'none'}
  //         },
  //     ]
  // },
  {
    path: '/agency_role',
    component: Layout,
    redirect: '/agency_role',
    name: 'agency_role',
    meta: { title: '系统管理', icon: 'ali_system' },
    children: [
      {
        path: '/agency_role',
        component: () => import('@/views/agencyMgt/agency_role'),
        name: 'agency_role',
        meta: { title: '角色信息', icon: 'none' }
      },
      {
        path: '/agency_user_info',
        component: () => import('@/views/agencyMgt/agency_user_info'),
        name: 'agency_user_info',
        meta: { title: '用户信息', icon: 'none' }
      }
      // {
      //     path: '/agency_info',
      //     component: () => import('@/views/agencyMgt/agency_info'),
      //     name: 'agency_user_info',
      //     meta: {title: '代理商信息', icon: 'none'}
      // },
    ]
  },
  {
    path: '/station',
    component: Layout,
    redirect: '/agencyMgt/station',
    name: 'station',
    meta: { title: '设备管理', icon: 'ali_device' },
    children: [
      {
        path: '/agencyMgt/time_standard',
        component: () => import('@/views/agencyMgt/time_standard'),
        name: 'time_standard',
        meta: { title: '收费标准', icon: 'none' }
      },
      {
        path: '/agencyMgt/current_limit',
        component: () => import('@/views/agencyMgt/current_limit'),
        name: 'current_limit',
        meta: { title: '充电参数', icon: 'none' }
      },
      {
        path: '/agencyMgt/station',
        component: () => import('@/views/agencyMgt/station'),
        name: 'station',
        meta: { title: '站点信息', icon: 'none' }
      },
      {
        path: '/agencyMgt/monitoring',
        component: () => import('@/views/agencyMgt/monitoring'),
        name: 'monitoring',
        meta: { title: '机柜信息', icon: 'none' }
      },
      // {
      //     path: '/agencyMgt/fire_belong',
      //     component: () => import('@/views/agencyMgt/fire_belong'),
      //     name: 'fire_belong',
      //     meta: {title: '消防归属', icon: 'none'},
      // },
      {
        path: '/agencyMgt/cabinet',
        component: () => import('@/views/agencyMgt/cabinet'),
        name: 'device_info',
        meta: { title: '设备信息', icon: 'none' },
        hidden: true
      },
      {
        path: '/agencyMgt/cabinet_detail',
        component: () => import('@/views/agencyMgt/cabinet_detail'),
        name: 'device_info',
        meta: { title: '机柜详情', icon: 'none' },
        hidden: true
      }
    ]
  },
  {
    path: '/marketingMgt',
    component: Layout,
    redirect: '/marketingMgt/coupon',
    name: 'marketingMgt',
    meta: { title: '营销管理', icon: 'ali_marketing' },
    children: [
      {
        path: '/marketingMgt/coupon',
        component: () => import('@/views/marketingMgt/coupon'),
        name: 'coupon',
        meta: { title: '优惠券', icon: 'none' }
      }
    ]
  },
  {
    path: '/orderMgt',
    component: Layout,
    hidden: false,
    redirect: '/order',
    meta: { title: '订单管理', icon: 'ali_order' },
    children: [
      // {
      //   path: '/order',
      //   name: 'order',
      //   component: () => import('@/views/orderMgt/order'),
      //   meta: { title: '充电订单', icon: 'none' }
      // },
      {
        path: '/socket_order',
        name: 'socket_order',
        component: () => import('@/views/orderMgt/socket_order'),
        meta: { title: '充电插座订单', icon: 'none' }
      },
      {
        path: '/box_order',
        name: 'box_order',
        component: () => import('@/views/orderMgt/box_order'),
        meta: { title: '充电仓位订单', icon: 'none' }
      },
      {
        path: '/refund_order',
        name: 'refund_order',
        component: () => import('@/views/orderMgt/refund_order'),
        meta: { title: '退款订单', icon: 'none' }
      }
    ]
  },
  {
    path: '/fireMgt',
    component: Layout,
    hidden: false,
    redirect: '/fire',
    meta: { title: '消防管理', icon: 'ali_fire' },
    children: [
      {
        path: '/fire_user',
        name: 'fire_user',
        component: () => import('@/views/fireMgt/fire_user'),
        meta: { title: '消防账号', icon: 'none' }
      },
      {
        path: '/fire_terminal',
        name: 'fire_terminal',
        component: () => import('@/views/fireMgt/fire_terminal'),
        meta: { title: '消防终端', icon: 'none' }
      },
      {
        path: '/fire_alarm',
        name: 'fire_alarm',
        component: () => import('@/views/fireMgt/fire_alarm'),
        meta: { title: '报警记录', icon: 'none' }
      },
      {
        path: '/fireMgt/fire_binding',
        component: () => import('@/views/fireMgt/fire_binding'),
        name: 'fire_binding',
        meta: { title: '终端绑定', icon: 'none' },
        hidden: true
      },
      // {
      //   path: '/fireMgt/dashboard',
      //   component: () => import('@/views/fireDashboard/index'),
      //   name: 'fire_dashboard',
      //   meta: { title: '消防仪表盘', icon: 'none' },
      //   hidden: false
      // }
    ]
  },
  {
    path: '/customerMgt',
    component: Layout,
    hidden: false,
    redirect: '/customer',
    meta: { title: '客户管理', icon: 'ali_customer' },
    children: [
      {
        path: '/customer',
        name: 'customer',
        component: () => import('@/views/customerMgt/customer'),
        meta: { title: '微信用户', icon: 'none' }
      }
    ]
  },
  {
    path: '/afterSalesMgt',
    component: Layout,
    hidden: false,
    redirect: '/feedback',
    meta: { title: '售后管理', icon: 'ali_after_sales' },
    children: [
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/afterSalesMgt/feedback'),
        meta: { title: '反馈留言', icon: 'none' }
      }
    ]
  },
  {
    path: '/statisticsMgt',
    component: Layout,
    hidden: false,
    redirect: '/statistics',
    meta: { title: '报表管理', icon: 'ali_report' },
    children: [
      // {
      //   path: '/incomeDateChart',
      //   name: 'incomeDateChart',
      //   component: () => import('@/views/statisticsMgt/incomeDateChart'),
      //   meta: { title: '日报表', icon: 'none' }
      // },
      // {
      //   path: '/incomeMonthChart',
      //   name: 'incomeMonthChart',
      //   component: () => import('@/views/statisticsMgt/incomeMonthChart'),
      //   meta: { title: '月报表', icon: 'none' }
      // },
      // {
      //   path: '/incomeYearChart',
      //   name: 'incomeYearChart',
      //   component: () => import('@/views/statisticsMgt/incomeYearChart'),
      //   meta: { title: '年报表', icon: 'none' }
      // },
      {
        path: '/trade_bill',
        name: 'trade_bill',
        component: () => import('@/views/statisticsMgt/trade_bill'),
        meta: { title: '交易账单', icon: 'none' }
      },
      {
        path: '/fund_bill',
        name: 'fund_bill',
        component: () => import('@/views/statisticsMgt/fund_bill'),
        meta: { title: '资金账单', icon: 'none' }
      }
    ]
  },
  {
    path: '/toolsMgt',
    component: Layout,
    hidden: false,
    redirect: '/tools',
    meta: { title: '实用工具', icon: 'system' },
    children: [
      {
        path: '/qrcode',
        name: 'incomeDateChart',
        component: () => import('@/views/tools/qrcode'),
        meta: { title: '批量生码', icon: 'none' }
      },
      {
        path: '/upgrade',
        name: 'upgrade',
        component: () => import('@/views/tools/upgrade'),
        meta: { title: '网关升级', icon: 'none' }
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    root: 'TemperatureData',
    hidden: false,
    redirect: '/dashboard'
  },
  {
    path: '*',
    component: () => import('@/views/404'),
    hidden: true,
    name: '404'
  }

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
